import React from 'react';
import { motion } from 'framer-motion';
import { FaCalendarAlt, FaMapMarkerAlt, FaClock, FaUsers } from 'react-icons/fa';

const EventsPage: React.FC = () => {
  const events = [
    {
      title: 'Tree Plantation Drive',
      date: 'June 15, 2026',
      location: 'Delhi Ridge Forest',
      time: '8:00 AM - 12:00 PM',
      participants: '100+',
      description: 'Join us for a massive tree plantation drive to increase green cover in Delhi.'
    },
    {
      title: 'Educational Workshop for Girls',
      date: 'June 20, 2026',
      location: 'Community Center, Mumbai',
      time: '2:00 PM - 5:00 PM',
      participants: '50+',
      description: 'Career guidance and skill development workshop for underprivileged girls.'
    },
    {
      title: 'Cow Shelter Maintenance',
      date: 'June 25, 2026',
      location: 'Gaushala, Rajasthan',
      time: '9:00 AM - 4:00 PM',
      participants: '30+',
      description: 'Volunteer day for cleaning and maintenance of cow shelter facilities.'
    },
    {
      title: 'Natural Disaster Relief Training',
      date: 'July 5, 2026',
      location: 'Training Center, Kolkata',
      time: '10:00 AM - 4:00 PM',
      participants: '40+',
      description: 'First aid and emergency response training for volunteers.'
    },
    {
      title: 'Elderly Care Program',
      date: 'July 10, 2026',
      location: 'Old Age Home, Bangalore',
      time: '11:00 AM - 3:00 PM',
      participants: '25+',
      description: 'Spend quality time with elderly residents and assist with daily activities.'
    },
    {
      title: 'Organic Farming Workshop',
      date: 'July 15, 2026',
      location: 'Farm, Punjab',
      time: '9:00 AM - 1:00 PM',
      participants: '35+',
      description: 'Learn sustainable farming techniques and organic cultivation methods.'
    }
  ];

  return (
    <div className="events-page">
      <section className="bg-gradient-to-r from-primary-blue to-primary-teal py-20">
        <div className="container-lg px-4 text-center text-white">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Events & Activities</h1>
            <p className="text-xl opacity-90 max-w-3xl mx-auto">
              Join our upcoming events and be part of meaningful activities that create positive change.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="section-padding">
        <div className="container-lg px-4">
          <h2 className="text-3xl font-bold mb-8">Upcoming Events</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {events.map((event, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="bg-white rounded-xl shadow-lg overflow-hidden"
              >
                <div className="p-6">
                  <div className="flex items-center text-primary-green mb-4">
                    <span className="mr-2"><FaCalendarAlt /></span>
                    <span className="font-semibold">{event.date}</span>
                  </div>
                  
                  <h3 className="text-xl font-bold text-gray-800 mb-4">{event.title}</h3>
                  
                  <div className="space-y-3 mb-6">
                    <div className="flex items-center text-gray-600">
                      <span className="mr-3"><FaMapMarkerAlt /></span>
                      <span>{event.location}</span>
                    </div>
                    
                    <div className="flex items-center text-gray-600">
                      <span className="mr-3"><FaClock /></span>
                      <span>{event.time}</span>
                    </div>
                    
                    <div className="flex items-center text-gray-600">
                      <span className="mr-3"><FaUsers /></span>
                      <span>{event.participants} participants</span>
                    </div>
                  </div>
                  
                  <p className="text-gray-700 mb-6">{event.description}</p>
                  
                  <button className="btn-primary w-full">
                    Register for Event
                  </button>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default EventsPage;